import React, { useEffect } from 'react';
import styles from '../components/styles/common.module.css';
import CompanyVision from '../components/individual/about_componey/CompanyVision';
import ImageBoard from '../components/individual/about_componey/ImageBoard';
import BenefitsSection from '../components/individual/about_componey/BenefitsSection';
import CorporateProfile from '../components/individual/about_componey/CorporateProfile';
import Timeline from '../components/individual/about_componey/TimeLine';
import WhyChooseUs from '../components/individual/about_componey/WhyChooseUs';
import PageTitle from '../components/PageTitle';
import useScrollToHash from '../components/useScrollToHash'; // Adjust path based on your folder


const About = () => {

   useScrollToHash(); 

  return (
    <>
      <PageTitle 
        title="About Us" 
        description="Learn about DG FutureTech's mission, vision, and our commitment to providing exceptional IT services and solutions."
      />
      <div className={styles.AboutSection}>
        <div id="company-vision" style={{ scrollMarginTop: "200px" }}><CompanyVision /></div>
       
        <div id="life-at-dgft" style={{ scrollMarginTop: "50px" }}><Timeline /></div>
        <div id="why-choose-us" style={{ scrollMarginTop: "50px" }}><WhyChooseUs /></div>
        <div id="benefits" style={{ scrollMarginTop: "100px" }}><BenefitsSection /></div>
        
      </div>
    </>
  );
};

export default About;
